import { showErrorMessage } from 'utilities/errorMessage/desktop';
import { domReady, setButtonStateDuringActivity } from 'utilities/dom';
import { getGiftCardBalance } from 'features/giftCard/api';
import { apiMessages } from 'ui/messages';
import { recaptcha } from 'features/recaptcha';
import { setGenericEvent } from 'features/tealium/ga4/custom';
import initGiftCard from 'pages/product/desktop/giftCard';

domReady(() => {

	window.initFormValidation(true, '.giftCardForm');

	const giftCardNumber = document.getElementById('GiftCardNumber');
	const pinNumber = document.getElementById('PinNumber');

	const giftCardForm = document.querySelector('.giftCardForm');
	const btnViewBalance = document.querySelector('.btnViewBalance');
	const gcBalanceSuccess = document.querySelector('.gift-cards__balance-result--success');
	const cardLastFour = document.querySelector('.cardLastFour');
	const cardAmountRemaining = document.querySelector('.cardAmountRemaining');
	const gcBalanceFailure = document.querySelector('.gift-cards__balance-result--failure');
	const $form = $('.giftCardForm');

	const {
		recaptchaSiteKeyCheckbox,
		recaptchaSiteKeyScore,
		recaptchaAction,
		recaptchaScoreType,
		recaptchaCheckboxType
	} = window.lp.pageData;
	const captcha = recaptcha({ siteKeyCheckbox: recaptchaSiteKeyCheckbox, siteKeyScore: recaptchaSiteKeyScore });

	const showInlineErrorMessage = (error, skipResetFields) => {

		gcBalanceFailure.innerHTML = error;
		gcBalanceFailure.classList.remove('hidden');
		gcBalanceSuccess.classList.add('hidden');

		if (!skipResetFields) {

			giftCardNumber.value = '';
			pinNumber.value = '';

		}

	};

	const hideRecaptchaCheckbox = () => {

		if (captcha.checkbox.isWidgetRendered()) {

			captcha.checkbox.resetWidget();
			captcha.checkbox.toggleWidgetVisibility(false);

		}

	};

	const showRecaptchaCheckbox = () => {

		const showWidget = () => {

			captcha.checkbox.toggleWidgetVisibility(true);

		};

		if (captcha.checkbox.isWidgetRendered()) {

			captcha.checkbox.resetWidget();
			showWidget();

		} else {

			const widgetLabelContainer = document.getElementById('recaptchaCheckboxLabel');
			captcha.checkbox
				.renderWidget({
					widgetContainer: 'recaptchaCheckbox',
					widgetLabelContainer,
					action: recaptchaAction
				})
				.then(showWidget);

		}

	};

	const applyGiftCard = (recaptchaToken) => {

		const request = getGiftCardBalance(
			{
				CardNumber: giftCardNumber.value,
				Pin: pinNumber.value,
				Token: recaptchaToken,
				RecaptchaIntegrationType: captcha.getActiveIntegrationType({
					scoreType: recaptchaScoreType,
					checkboxType: recaptchaCheckboxType
				}),
				RecaptchaAction: recaptchaAction
			},
			(response) => {

				const cardNumber = response.OrderResponseModel.CardNumber;

				cardLastFour.innerHTML = cardNumber.substr(cardNumber.length - 4);
				cardAmountRemaining.innerHTML = response.OrderResponseModel.FormattedAmount;

				gcBalanceSuccess.classList.remove('hidden');
				gcBalanceFailure.classList.add('hidden');

				giftCardNumber.value = '';
				pinNumber.value = '';

				hideRecaptchaCheckbox();

				setGenericEvent({
					event_name: 'giftcards_viewbalance_submit'
				});

			},
			(response) => {

				const apiRequestError = !response || !response.OrderResponseModel || !response.ErrorMessages;
				if (apiRequestError) {

					showErrorMessage({
						errors: apiMessages.error
					});

					setGenericEvent({
						event_name: 'giftcards_viewbalance_submit'
					});

					return;

				}

				const recaptchaSuccess = response.OrderResponseModel.IsRecaptchaSuccess;
				if (!recaptchaSuccess) {

					showRecaptchaCheckbox();
					return;

				}

				hideRecaptchaCheckbox();
				showInlineErrorMessage(response.ErrorMessages[0]);

				setGenericEvent({
					event_name: 'giftcards_viewbalance_submit'
				});

			}
		);

		setButtonStateDuringActivity(btnViewBalance, request);

	};

	const applyGiftCardWithRecaptchaToken = () => {

		if (captcha.checkbox.isWidgetRendered() && captcha.checkbox.isWidgetVisible()) {

			const token = captcha.checkbox.getToken();
			if (token) {

				applyGiftCard(token);

			}

		} else {

			const tokenRequest = captcha.score.getToken(recaptchaAction).then(applyGiftCard, (error) => {

				showErrorMessage({
					errors: error.message
				});

			});

			setButtonStateDuringActivity(btnViewBalance, tokenRequest);

		}

	};

	btnViewBalance.addEventListener('click', (e) => {

		e.preventDefault();

		if ($form.valid() && btnViewBalance.getAttribute('aria-disabled') !== 'true') {

			gcBalanceFailure.innerHTML = '';
			gcBalanceSuccess.classList.add('hidden');

			applyGiftCardWithRecaptchaToken();

		} else {

			giftCardForm?.querySelector('input.error')?.focus();

		}

	});

	initGiftCard().init();

});
